/**
 * Included into the footer of pages.
 */

import "./lib/AnalyticsSetup";

(window as any).plaudit = {};

require('./scripts/plugins.js');
require('./scripts/plaudit.Stopwatch.js');
require('./scripts/plaudit.SlideManager.js');
require('./scripts/plaudit.site.js');

import Slider from './component/Slider/Slider';
Slider();

import SiteAnimations from './component/SiteAnimations';
new SiteAnimations([
	{
		observedSelector: '.featuredContent, .richContent, .listItemGroup, .cardGroup, .iconItemGroup, .memberCallout, .slider',
		options: {
			rootMargin: '0px 0px',
			threshold: .5
		}
	},
	{
		observedSelector: '.__entry .feature-container, .callToAction',
		options: {
			rootMargin: '0px 0px',
			threshold: 0
		}
	}
]);